import { VTable } from 'roosterjs-editor-dom';
import { editTable, formatTable, replaceWithNode } from 'roosterjs-editor-api';
import type { default as PluginUtils, SpellChecker, ResizeObserver } from '../schema/PluginUtils';

export default function createPluginUtils(editorDiv: HTMLDivElement): PluginUtils {
    return {
        replaceWithNode,
        editTable,
        formatTable,
        createVTable: (td: HTMLTableCellElement) => new VTable(td),
        observeMutation: getObserveMutationFunc(editorDiv),
        observeResize: getObserveResizeFunc(editorDiv),
        spellCheck: getSpellCheckFunc(editorDiv),
    };
}

function getObserveMutationFunc(editorDiv: HTMLDivElement) {
    return (callback: MutationCallback, options?: MutationObserverInit) => {
        if (typeof MutationObserver != 'undefined') {
            const observer = new MutationObserver(callback);
            observer.observe(editorDiv, options);
            return () => {
                observer.disconnect();
            };
        } else {
            return () => {};
        }
    };
}

function getObserveResizeFunc(editorDiv: HTMLDivElement) {
    return (observer: ResizeObserver, options: { box: string }) => {
        const parent = editorDiv.parentElement;

        if (parent) {
            observer.observe(parent, options);
        }
    };
}

function getSpellCheckFunc(editorDiv: HTMLDivElement) {
    return <T>(spellChecker: SpellChecker<T>, filterSelector?: string) => {
        return spellChecker.spellCheck(editorDiv, filterSelector);
    };
}
